// Public landing uses normal browser navigation and form submission. The
// tracked bundle changes on app pages, forcing a full reload when Turbo enters.
import { Application } from "@hotwired/stimulus"
import AnalyticsController from "./controllers/analytics_controller"
import HeroVideoController from "./controllers/hero_video_controller"
import ToastController from "./controllers/toast_controller"

const application = Application.start()
application.register("analytics", AnalyticsController)
application.register("hero-video", HeroVideoController)
application.register("toast", ToastController)

// The head queues config and events immediately. Load the library after page
// resources, or on interaction so an early signup does not wait for idle time.
let analyticsStarted = false
function loadAnalytics() {
  if (analyticsStarted) return
  analyticsStarted = true
  const script = document.createElement("script")
  script.async = true
  script.src = "https://www.googletagmanager.com/gtag/js?id=G-G2DZCYB96Z"
  document.head.append(script)
  document.removeEventListener("pointerdown", loadAnalytics)
  document.removeEventListener("keydown", loadAnalytics)
}
function scheduleAnalytics() {
  if ("requestIdleCallback" in window) window.requestIdleCallback(loadAnalytics, { timeout: 1000 })
  else setTimeout(loadAnalytics, 0)
}
if (document.readyState === "complete") scheduleAnalytics()
else window.addEventListener("load", scheduleAnalytics, { once: true })
document.addEventListener("pointerdown", loadAnalytics, { once: true, passive: true })
document.addEventListener("keydown", loadAnalytics, { once: true })
